import React from 'react';
import DetailsSection from './DetailSection.jsx';
import { formatCurrency, formatDate } from '../../../utils/helpers';
import {getCalculatedInterest, getCurrentBalanceWithCalculatedInterest} from "../../../utils/renewalHelpers";

/** @import {InstructionDetailsProps} from './InstructionDetailsTypes' */
/** @import {InstructionDetail} from '../MaturityOptionsTypes' */
const InstructionDetails = (/** @type {InstructionDetailsProps} */ { account, instruction, linkedAccounts, rate, term }) => {
    const getInstructionDetails = () => {

        /** @type {InstructionDetail[]} */
        let line1 = [];

        /** @type {InstructionDetail[]} */
        let line2 = [];
        if (instruction?.name === "RolloverPartialFundPayoutInterest") {
            line1 = [
                { title: 'You’ve chosen to', value: 'Renew some of your balance', additionalInfo: `On ${formatDate(account?.maturity?.maturityDate)}` },
                { title: 'Fixed term', value: `${term}` },
                { title: 'Renewal rate', value: `${rate}% AER*` }
            ];
            line2 = [
                { title: 'Renewal amount', value: `${formatCurrency(Number(instruction?.options?.partialRolloverAmount), true)}` },
                { title: 'Transfer amount', value: `${formatCurrency(Number(instruction?.options?.remainingBalanceWithdrawalAmount), true)}`, additionalInfo: `Paid to your ${instruction?.options?.selectedTransferAccount?.product?.name} – ${instruction?.options?.selectedTransferAccount.accountNumber}` },
                { title: 'Interest amount', value: `${formatCurrency(getCalculatedInterest(account))}`, additionalInfo: `Paid to your linked account – ${linkedAccounts ? linkedAccounts[0]?.accountNumber : ''}` }
            ];
        } else if (instruction?.name === "RolloverAllFunds") {
            line1 = [
                { title: 'You’ve chosen to', value: 'Renew everything', additionalInfo: `On ${formatDate(account?.maturity?.maturityDate)}` },
                { title: 'Fixed term', value: `${term}` },
                { title: 'Renewal rate', value: `${rate}% AER*` }
            ];
            line2 = [
                { title: 'Renewal amount', value: `${formatCurrency(getCurrentBalanceWithCalculatedInterest(account))}` }
            ];
        } else if (instruction?.name === "RolloverPayawayInterest") {
            line1 = [
                { title: 'You’ve chosen to', value: 'Renew original balance only', additionalInfo: `On ${formatDate(account?.maturity?.maturityDate)}` },
                { title: 'Fixed term', value: `${term}` },
                { title: 'Renewal rate', value: `${rate}% AER*` }
            ];
            line2 = [
                { title: 'Renewal amount', value: `${formatCurrency(account.balance)}` },
                { title: 'Interest amount', value: `${formatCurrency(getCalculatedInterest(account))}`, additionalInfo: `Paid to your linked account – ${linkedAccounts ? linkedAccounts[0]?.accountNumber : ''}` },
                { title: '', value: '' }
            ];
        }

        return { line1, line2 };
    };

    const { line1, line2 } = getInstructionDetails();

    return (
        <>
            <DetailsSection details={line1} />
            <DetailsSection details={line2} />
        </>
    );
};

export default InstructionDetails;